import React from 'react';

import { headerView as HeaderView } from '../shared/headerView';

// import { sidebarView as SidebarView } from '../shared/sidebarView';

import { isEmpty } from 'lodash';
import AutoLogout from '../modules/AutoLogout';
import { cloneDeep } from 'lodash';
import { fetch } from '../modules/httpServices'; 
import APP from '../modules/index';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const checkUserLoginHoc = (WrapperFile) => {
  return class CheckUserLogin extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isAdmin: true,
        openModal: false,
        openModalAzure: false,
        newPassword: '',
        oldPassword: '',
        confirmPassword: ''
      };
    }
    componentDidMount() {
      if (this.userNotLogin() && this.props.match.path !== '/') {
        this.goToPage('/');
      } else if (!this.userNotLogin() && this.props.match.path === '/') {
        this.goToPage('/home');
      }
    }
    userNotLogin = () => {
      const _token = window.localStorage.getItem('Token');
      return isEmpty(_token);
    };
    onLogout = () => {
      localStorage.clear();
      sessionStorage.clear();
      this.goToPage('/');
    };
    goToPage = (path) => {
      this.props.history.push(path);
    };
    openModalPopup = () => {
      this.setState({ openModal: true });
    };
    openModalPopupAzure = () => {
      this.setState({ openModalAzure: true });
    };
    closePopup = () => {
      this.setState({ openModal: false, openModalAzure: false });
    };
    onChangePswd = ({ eve, id, val }) => {
      const _state = cloneDeep(this.state);
      _state[id] = val;
      this.setState(_state);
    };
    onHandleSubmit = (eve) => {
      const _state = cloneDeep(this.state);
      eve.preventDefault();
      if (_state.newPassword === _state.confirmPassword) {
        const id = localStorage.getItem('userid');
        const RequestBody = {
          oldPassword: _state.oldPassword,
          newPassword: _state.newPassword,
          id: id
        };
        fetch.post({
          url: APP.Constants.SERVICE_URLS.CHANGE_PSWD,
          requestBody: RequestBody,
          callbackHandler: (res) => {
            const { status, payload } = res;
            if (APP.Constants.SUCCESS === status) {
              if (payload === 'Old Password is incorrect.Please try again.') {
                // alert(payload);
                toast.error(`${payload}`, { theme: 'colored' });
              } else {
                _state.openModal = false;
                this.setState(_state);
              }
            }
          }
        });
      } else {
        // alert('New Password & Confirm Password are not same');
        toast.error(`${'New Password & Confirm Password are not same'}`, { theme: 'colored' });
      }
    };
    render() {
      // const { isAdmin } = this.state;
      const { path } = this.props.match;
      if (path === '/' || path === '/not-found') {
        return (
          <div
            className={`page page--${
              path === '/' ? 'login' : path === '/home' ? 'home' : 'not-found'
            }`}
          >
            <WrapperFile {...this.props} goToPage={this.goToPage} />
          </div>
        );
      } else {
        return (
          <React.Fragment>
            {path === '/testdesign' || path === '/testdatageneration' ? <></> : 
            <HeaderView 
              onLogout={this.onLogout}
              onChangePswd={this.onChangePswd}
              openModalPopup={this.openModalPopup}
              openModalPopupAzure={this.openModalPopupAzure}
              closePopup={this.closePopup}
              onHandleSubmit={this.onHandleSubmit}
              {...this.state}  
            />}
            {/* <HeaderView onLogout={this.onLogout} {...this.state} /> */}
            <div
              className={`page ${
                path === '/home' || path === '/testmanagement'
                  ? 'page--home'
                  : ''
              }`}
            >
              <div className='page__container'>
                <WrapperFile {...this.props} goToPage={this.goToPage} />
              </div>
            </div>
          </React.Fragment>
        );
      }
      // else {
      //   return (
      //     <React.Fragment>
      //       <HeaderView onLogout={this.onLogout} {...this.state} />
      //       <div className='page'>
      //         {/* <SidebarView location={this.props.location} isAdmin={isAdmin} /> */}
      //         <div className='page__container'>
      //           <WrapperFile {...this.props} goToPage={this.goToPage} />
      //         </div>
      //       </div>
      //     </React.Fragment>
      //   );
      // }
    }
  };
};
